export default __webpack_public_path__ + "static/media/Implantologie_01.179914dc.png";